import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useGetRechnungslaeufeMutation, useStarteRechnungslaufMutation } from '../../api/FakturaAPI';
import { formatToEuroDate } from '../../util/DateUtils';
import Footer from '../footer/Footer';
import LandingpageHeader from '../header/LandingpageHeader';
import { IRechnungslauf } from '../../types/Types';
import { LoadingModal } from '../../component/LoadingModal/LoadingModal';

export default function RechnungslaufListe() {

    //const dispatch = useDispatch<AppDispatch>();
    const [loading, setLoading] = useState(false);
    const { t } = useTranslation();
    const navigate = useNavigate();

    const [liste, setListe] = useState<IRechnungslauf[]>([]);
    const [getRechnungsanlage] = useGetRechnungslaeufeMutation();
    const [starteRechnungslauf] = useStarteRechnungslaufMutation();

    const lade = () => {
        setLoading(true);
        getRechnungsanlage().unwrap()
            .then((data) => setListe(data))
            .finally(() => setLoading(false));
    }

    const starteRlauf = async (e: IRechnungslauf, echtlauf: boolean) => {

        setLoading(true);
        const { blob, filename } = await starteRechnungslauf({ bis: e.bisdatum, echtlauf: echtlauf, uid: e.uid })
            .unwrap()
            .finally(() => setLoading(false))
            ;

        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);

    }

    const probelauf = async (e: IRechnungslauf) => {
        starteRlauf(e, false);
    }

    const echtlauf = async (e: IRechnungslauf) => {
        starteRlauf(e, true);
    }

    useEffect(() => {
        lade();
    }, []);

    return (
        <>
            <div>

                <LandingpageHeader />

                <div style={{ padding: "20px" }}>

                    <div className="container">
                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                            <button
                                onClick={() => {
                                    navigate({
                                        pathname: "/",
                                        search: ""
                                    });
                                }}

                                style={{ marginBottom: "20px" }}
                                className=' btn btn-outline-primary'
                            >
                                <i className="bi bi-arrow-left"></i> {t('deTranslation.auftragDetails.backButton')}
                            </button>
                        </div>

                        <h3>Rechnungsläufe</h3>

                        <p>
                            Anzahl {liste.length}
                        </p>

                        <button className="btn btn-primary" onClick={() => navigate("/faktura/rechnungslaufDetail", { state: { view: 'create' } })}><i className="bi bi-plus"></i> Neuanlage</button>


                        <table className="table">

                            <tr>
                                <th>Name</th>
                                <th>Bis</th>
                                <th>Option</th>
                            </tr>

                            {liste.map((e, index) => <>
                                <tr key={index}>
                                    <td>{e.name}</td>
                                    <td>{formatToEuroDate(e.bisdatum)}</td>
                                    <td>
                                        <button className="btn btn-success" onClick={() => probelauf(e)}><i className="bi bi-play"></i> Probelauf</button>
                                        <button className="btn btn-danger" onClick={() => echtlauf(e)}><i className="bi bi-play"></i> Echtlauf</button>
                                        <button className="btn btn-primary" onClick={() => navigate("/faktura/vorschau?id=" + e.uid)}><i className="bi bi-file-earmark-text"></i> Vorschau</button>
                                        <button className="btn btn-secondary" onClick={() => navigate("/faktura/rechnungslaufDetail", { state: { view: 'detail', id: e.uid } })}><i className="bi bi-list"></i> Details</button>
                                    </td>
                                </tr>
                            </>)}

                        </table >

                    </div>
                </div>

                <LoadingModal show={loading} text="Bitte warten..." />

                <Footer />
            </div >

        </>
    );
}
